module.exports = __webpack_public_path__ + "img/icon_sm_cgml.44260752.png";